import { CancelToken } from 'axios';
import { CANCEL } from 'redux-saga';

import fetch from 'core/fetch';
import CONFIG from 'core/config';

export function getSports(params) {
  const source = CancelToken.source();
  const options = {
    cancelToken: source.token,
    url: `${CONFIG.hosts.publicApi}/sports`,
    method: 'GET',
    params,
  };
  const promise = fetch.request(options);
  promise[CANCEL] = source.cancel;
  return promise;
}

export function getNewspaperKinds(params) {
  const source = CancelToken.source();
  const options = {
    cancelToken: source.token,
    url: `${CONFIG.hosts.api}/newspaper_kinds`,
    method: 'GET',
    params,
  };
  const promise = fetch.request(options);
  promise[CANCEL] = source.cancel;
  return promise;
}
